import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  quill: {
    '& > .ql-toolbar.ql-snow': {
      backgroundColor: '#CDCEDA !important',
    },
    '& > .ql-container.ql-snow': {
      backgroundColor: 'white !important',
    },
    '& .ql-editor.ql-blank::before': {
      color: '#9799B1 !important',
      fontSize: '14px !important',
      fontStyle: 'normal !important',
      opacity: 1,
    },
    '& .ql-editor': {
      fontSize: '14px !important',
      fontFamily: 'Poppins !important',
    },
  },
  quillWhiteBackground: {
    '& > .ql-container': {
      '& > .ql-snow': {
        backgroundColor: 'white !important',
      },
    },
  },
  quillMultiline: {
    '& > .ql-container': {
      height: 200,
    },
  },
  error: {
    border: `2px solid ${theme.palette.error.main}`,
  },
}));

export default useStyles;
